import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production" && !window.Capacitor?.isNativePlatform?.()) {
  window.addEventListener("load", () => {
    const main = document.querySelector("script[src*='/static/js/main']")?.getAttribute("src") || "";
    const version = (main.match(/main\.([^.]+)\.js/) || [])[1] || "1";
    navigator.serviceWorker.register(`/sw.js?v=${version}`).catch(() => {});
  });
}
